import React from "react";

export const HERO_BENEFITS = [
  {
    id: "night-leads",
    text: "intercepts night leads in 26 seconds",
    highlights: [/26 seconds/],
  },
  {
    id: "conversion",
    text: "doubles (x2) your form conversion",
    highlights: [/doubles \(x2\)/],
  },
  {
    id: "calendar",
    text: "qualifies the lead, and books your calendar.",
    highlights: [/qualifies/, /books/],
  },
];

export const highlightBenefitText = (text, highlightPatterns) => {
  let parts = [{ text, highlight: false }];

  highlightPatterns.forEach((pattern) => {
    const next = [];
    parts.forEach((part) => {
      if (part.highlight) {
        next.push(part);
        return;
      }
      const match = part.text.match(pattern);
      if (!match) {
        next.push(part);
        return;
      }
      const index = match.index;
      const before = part.text.slice(0, index);
      const matched = match[0];
      const after = part.text.slice(index + matched.length);
      if (before) next.push({ text: before, highlight: false });
      next.push({ text: matched, highlight: true });
      if (after) next.push({ text: after, highlight: false });
    });
    parts = next;
  });

  return parts.map((part, index) =>
    part.highlight ? (
      <span key={index} className="cursor-neon">
        {part.text}
      </span>
    ) : (
      <React.Fragment key={index}>{part.text}</React.Fragment>
    ),
  );
};
